// import VT from '@/store/types';

export default {
  // [VT.SAMPLE_SETS_LIST]: (state, { data, status }) => {
  //   state.sampleSetsList = { data, status };
  // },
};
